module.exports = __webpack_public_path__ + "img/woman-people.49d0b079.svg";